import { useLazyLoadedRolesQuery } from '#app/__generated__/relay/useLazyLoadedRolesQuery.graphql.js';
import { graphql, useLazyLoadQuery } from '@contra/relay';
import { useMemo } from 'react';

type Role = {
  __typename: 'Role';
  id: string;
  name: string;
};

export const useLazyLoadedRoles = (): Role[] => {
  const { suggestedRoles } = useLazyLoadQuery<useLazyLoadedRolesQuery>(
    graphql`
      query useLazyLoadedRolesQuery {
        suggestedRoles {
          edges {
            node {
              __typename
              id
              name
            }
          }
        }
      }
    `,
    {},
  );

  return useMemo(() => {
    return suggestedRoles.edges.map(({ node }) => node);
  }, [suggestedRoles]);
};
